import { render, staticRenderFns } from "./open-app.vue?vue&type=template&id=09e3393f&scoped=true&"
import script from "./open-app.vue?vue&type=script&lang=js&"
export * from "./open-app.vue?vue&type=script&lang=js&"
import style0 from "./open-app.vue?vue&type=style&index=0&id=09e3393f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3393f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e3393f')) {
      api.createRecord('09e3393f', component.options)
    } else {
      api.reload('09e3393f', component.options)
    }
    module.hot.accept("./open-app.vue?vue&type=template&id=09e3393f&scoped=true&", function () {
      api.rerender('09e3393f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/open-app.vue"
export default component.exports